<template lang="pug">
  b-row.mb-5
    b-col
      models-form(:action='action')
</template>

<script>
import ModelsForm from '@views/container/manager/globals/machines/models/Form'

export default {
  name: 'manager-machines-models-new',
  components: {
    ModelsForm,
  },
  props: {
    action: String,
  },
}
</script>
